import { useAtomValue } from "jotai";
import { activePopupState } from "../../../state/components/popup";
import type { PopupInfo } from "../../../state/components/popup";

interface AlertPopupInfo extends PopupInfo {
  onOk?: (hide: () => void) => void;
}

const Alert = ({ hide }: { hide: () => void }) => {
  const info = useAtomValue(activePopupState("alert")) as AlertPopupInfo | null;
  const onOk = info?.onOk;

  return (
    <div
      className={"jf-popup-alert"}
      role={"alertdialog"}
      aria-live={"assertive"}
    >
      <div className={"jf-popup-alert-title"}>{info?.message}</div>
      <div className={"jf-popup-alert-content"}>
        {onOk ? (
          <>
            <button className={"outline-btn"} onClick={() => onOk(hide)}>
              Yes
            </button>
            <button onClick={hide}>No</button>
          </>
        ) : (
          <button className={"outline-btn"} onClick={hide}>
            OK
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;
